export default __webpack_public_path__ + "static/media/banjos_logo_g.d17e9c75.png";